import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { ServiceOrderService } from '../../../core/services/service/service-order/service-order.service'
import { ServiceOrder } from '../../../features/service/service-order/service-order.component'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { MatExpansionModule } from '@angular/material/expansion'
import { SearchFormOsComponent } from './form-search-os/form-search-os.component'
import { TableListFixedComponent } from '../../../shared/components/table-list-fixed/table-list-fixed.component'
import { JsonPipe } from '@angular/common'
import { TableListOSComponent } from '../../../shared/components/table-list-os/table-list-os.component'
import { ServiceOrderReplier } from '../../../features/service/service-order-replier/service-order-replier.component'
import { FormSearchOsProposalClientComponent } from '../../../shared/components/form-search-os-proposal-client/form-search-os-proposal-client.component'
import { FormSearchQuoteRequestTgNewComponent } from '../../../shared/components/form-search-quote-request-tg-new/form-search-quote-request-tg-new.component'
import { ModalOrderServiceProposalComponent } from '../../../features/service/modal-order-service-proposal/modal-order-service-proposal.component'

@Component({
  selector: 'service-order',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MatPaginator,
    MatExpansionModule,
    SearchFormOsComponent,
    TableListFixedComponent,
    JsonPipe,
    TableListOSComponent,
    FormSearchOsProposalClientComponent,
    FormSearchQuoteRequestTgNewComponent,
  ],
  templateUrl: './service-order.component.html',
  styleUrl: './service-order.component.scss',
  providers: [ServiceOrderService, AuthService],
  standalone: true,
})
export class ServiceOrderComponent implements OnInit {
  constructor(
    private serviceOrderService: ServiceOrderService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  searchResult: any = {}
  loading = false
  // searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  searchForm: any = { search: false, model: {} }
  inputSearch = ''
  columns: any[] = [
    {
      keyColumn: 'os_event',
      key: 'os_event',
      description: 'Evento',
    },
    // {
    //   keyColumn: 'nameEvent',
    //   key: 'nomeEvento',
    //   description: 'Evento',
    // },
    {
      keyColumn: 'os_client',
      key: 'os_client',
      description: 'Cliente',
    },
    {
      keyColumn: 'os_consultant',
      key: 'os_consultant',
      description: 'Consultor',
    },
    {
      keyColumn: 'os_period_new',
      key: 'os_period',
      description: 'Periodo',
    },
    // {
    //   keyColumn: 'descricaoStatusOs',
    //   key: 'descricaoStatusOs',
    //   description: 'Status',
    // },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, replierItem: false },
      description: 'Ações',
    },
  ]
  screen = 'tipo serviço'

  ngOnInit() {
    this.checkColumnAction()
    // this.getListItems()
    // this.searchOs()
    this.getSearchItems({
      codigoTg: '',
      cliente: '',
      subCliente: '',
      consultor: '',
      consultorComercial: '',
      nomeEvento: '',
      dataInicio: '',
      dataFinal: '',
      consultorOperacional: '',
    })
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
        replierItem: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  getSearchItems(model: any) {
    this.loading = true
    this.serviceOrderService
      .searchPagedServiceOrderByProposal(this.page, this.rows, model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: PagedContactTypeResponse) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchOs() {
    this.loading = true

    const item = {
      codigoOs: '',
      evento: '',
      dataInicio: '',
      dataFinal: '',
      statusId: null,
      codigoTg: '',
      clienteId: null,
    }

    this.searchResult = item

    this.serviceOrderService
      .searchPagedServiceOrder(this.page, this.rows, item)
      .subscribe({
        next: (response: any) => {
          this.loading = false
          this.treatResponse(response)
        },
        error: (err: any) => {
          console.error(err.message)
        },
      })
  }

  search(event: any) {
    this.searchForm = event
    this.page = 1
    this.uploadList()
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
    // this.search(this.searchResult)
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
    // this.search(this.searchResult)
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1
    this.uploadList()
  }

  uploadList() {
    if (this.searchForm.search) {
      this.getSearchItems(this.searchForm.model)
    } else {
      this.getSearchItems({
        codigoTg: '',
        cliente: '',
        subCliente: '',
        consultor: '',
        consultorComercial: '',
        nomeEvento: '',
        dataInicio: '',
        dataFinal: '',
        consultorOperacional: '',
      })
    }
    // this.getListItems()
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }

    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.serviceOrderService
      .listPagedServiceOrder(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  // searchListItems() {
  //   this.loading = true
  //   this.serviceOrderService
  //     .searchPagedServiceOrder(this.page, this.rows, this.searchForm)
  //     .subscribe({
  //       next: (response: any) => {
  //         this.treatResponse(response)
  //       },
  //       error: (err: PagedContactTypeResponse) => { },
  //       complete: () => {
  //         this.loading = false
  //       },
  //     })
  // }

  replierItem(item: any) {
    /*

  ordemServicoId: "string",
  ordemServicoIds: ["string"],
  horaInicial: "string",
  horaFinal: "string",
  observacao: true,
  listaPassageiros: true,
  itinerarios: true

*/
    const dialogRef = this.dialog.open(ServiceOrderReplier, {
      data: { item: item, edit: true },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  selectOsProposalClient(item: any) {
    const dialogRef = this.dialog.open(ModalOrderServiceProposalComponent, {
      data: { item },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  editItem(item: any) {
    const contratoItemId = item.contratoItemId
    const idOs = item.codigoOs
    const dataFim = item.dataFinal
    const dataInicio = item.dataInicio

    const dialogRef = this.dialog.open(ServiceOrder, {
      data: { item, contratoItemId, idOs, dataInicio, dataFim, edit: true },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
  }

  newPriceQuote() {
    const dialogRef = this.dialog.open(ServiceOrder, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { edit: false },
    })

    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }
}
